var initializeContactBlock = function(block){

	var map = initMap(jQuery('#map'));

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-contact').each(function(){
		initializeContactBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=contact', initializeContactBlock);



function initMap($el) {

    var $markers = $el.find('.marker');

    var mapArgs = {
        mapTypeControl		: false,
		scaleControl		: false,
		streetViewControl	: false,
		rotateControl		: false,
		fullscreenControl	: false,
		scrollwheel			: false,
		clickableIcons		: false,
        zoom        		: 13,
        styles  			: mapStyles
    };
    
    var map = new google.maps.Map($el[0], mapArgs);

    map.markers = [];
    
    $markers.each(function(){
        initMarker(jQuery(this), map);
    });

    centerMap(map);

    return map;
    
}


function initMarker($marker, map) {

    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
    };

    var marker = new google.maps.Marker({
        position : latLng,
        map: map
    });

    map.markers.push(marker);

    if($marker.html()){

        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open(map, marker);
        });
    }
}


function centerMap(map) {

    var bounds = new google.maps.LatLngBounds();
    
    map.markers.forEach(function(marker){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    if( map.markers.length == 1 ){
        map.setCenter(bounds.getCenter());
    } else{
        map.fitBounds(bounds);
    }
    
}
